import { Component } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-header-language',
  templateUrl: './header-language.component.html',
  styleUrls: ['./header-language.component.scss']
})
export class HeaderLanguageComponent {
  idiomas = [
    { value: 'es', idioma: 'Español' },
    { value: 'en', idioma: 'English' }
  ];

  constructor(private language: LanguageService) { }

  get idiomaSelected(): string {
    return this.language.currentLanguage;
  }

  useLanguage(lang: string): void {
    this.language.useLanguage(lang);
  }
}
